<template>
  <!-- プロフィール表示下部(アイコン/名前/詳細情報) -->
  <ul class="c-blog_pagination">
    <li class="c-blog_paginationItem c-blog_paginationItem-prev">
      <NuxtLink
        class="c-blog_paginationLink"
        :to="`/blogs/${user.id}/${previousBlog.id}`"
        v-if="previousBlog"
      >
        <CoconalaIcon
          name="chevron-left"
          size="18px"
        />
        <span v-if="isPC">{{ $util.truncate(previousBlog.title, MAX_TITLE) }}</span>
      </NuxtLink>
    </li>
    <li class="c-blog_paginationItem c-blog_paginationItem-back">
      <NuxtLink :to="`/blogs/${user.id}`">
        一覧に戻る
      </NuxtLink>
    </li>
    <li class="c-blog_paginationItem c-blog_paginationItem-next">
      <NuxtLink
        class="c-blog_paginationLink"
        :to="`/blogs/${user.id}/${nextBlog.id}`"
        v-if="nextBlog"
      >
        <span v-if="isPC">{{ $util.truncate(nextBlog.title, MAX_TITLE) }}</span>
        <CoconalaIcon
          name="chevron-right"
          size="18px"
        />
      </NuxtLink>
    </li>
  </ul>
</template>
<script>
// vuex
import { mapGetters, mapState } from 'vuex'

const MAX_TITLE = 25

export default {
  name: 'BlogPagination',
  data() {
    return {
      MAX_TITLE
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    ...mapState('pages/blogs/user/blog', ['previousBlog', 'nextBlog']),
    user() {
      return this.$store.state.pages.users.user
    }
  }
}
</script>
<style lang="scss" scoped>
.c-blog {
  &_pagination {
    margin-bottom: 32px;
    border-top: 1px solid $color-border-base;
    padding: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &_paginationItem {
    min-width: 60px;
    &-back {
      margin: 0 2em;
      border-left: 1px solid $color-border-base;
      border-right: 1px solid $color-border-base;
      width: 20%;
      text-align: center;

      a {
        display: inline-block;
        padding: 1em;
        color: $color-font-base;
        @include link-effect;
        i {
          color: $color-gray-600;
        }
      }
    }
    &-prev {
      width: 40%;
      text-align: right;

      span {
        text-align: left;
        margin-left: 8px;
      }
    }
    &-next {
      width: 40%;

      span {
        margin-right: 8px;
      }
    }
  }
  &_paginationLink {
    display: inline-flex;
    align-items: center;
    color: $color-font-base;
    font-size: 14px;
    font-weight: bold;
    @include link-effect;
    i {
      color: $color-gray-600;
    }
  }
}

@media (max-width: $breakpoint-m) {
  .c-blog {
    &_pagination {
      margin-bottom: 24px;
      border-top: 0;
      border-bottom: 1px solid $color-gray-200;
    }

    &_paginationItem {
      &-prev {
        width: auto;
      }

      &-next {
        width: auto;
      }

      &-back {
        width: auto;
      }
    }
    &_paginationLink {
      display: inline-block;
      padding: 1em;
      color: $color-font-base;
    }
  }
}
</style>
